import type { AllCMSPageFields } from '@/cms/fields/mappers/common'
import * as React from 'react'
import { PageFieldsContext } from '../context'

export function useCMSPageField<K extends keyof AllCMSPageFields>(fieldName: K): AllCMSPageFields[K] {
  const fields = React.use(PageFieldsContext)
  if (!fields) {
    throw new Error('Attempted to use \'useCMSPageField\' before initializing PageFieldsContext.')
  }

  return fields[fieldName]
}
